import { useState } from 'react';
import {
  FormControl,
  InputLabel,
  OutlinedInput,
  InputAdornment,
  IconButton,
  FormHelperText,
  Box,
} from '@mui/material';
import Visibility from '@mui/icons-material/Visibility';
import VisibilityOff from '@mui/icons-material/VisibilityOff';
import PropTypes from 'prop-types';

const propTypes = {
  label: PropTypes.string.isRequired,
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  required: PropTypes.bool.isRequired,
  error: PropTypes.bool,
  helperText: PropTypes.string,
  helperTextStyle: PropTypes.oneOf(['error', 'info']),
  fullWidth: PropTypes.bool,
};

const PasswordInput = ({
  label,
  value,
  onChange,
  required,
  error,
  helperText,
  helperTextStyle = 'error',
  fullWidth = true,
}) => {
  const [showPassword, setShowPassword] = useState(false);

  return (
    <FormControl
      variant="outlined"
      fullWidth={fullWidth}
      required={required}
      error={error}>
      <InputLabel>{label}</InputLabel>
      <OutlinedInput
        type={showPassword ? 'text' : 'password'}
        value={value}
        onChange={onChange}
        fullWidth={fullWidth}
        endAdornment={
          <InputAdornment position="end">
            <IconButton
              onClick={() => setShowPassword(!showPassword)}
              onMouseDown={(e) => e.preventDefault()}
              edge="end"
              color="info">
              {showPassword ? <VisibilityOff /> : <Visibility />}
            </IconButton>
          </InputAdornment>
        }
        label={label}
      />
      <Box sx={{ minHeight: '20px' }}>
        {helperText && (
          <FormHelperText
            sx={{
              color: helperTextStyle === 'info' ? 'text.secondary' : undefined,
              margin: 0,
              lineHeight: '20px',
            }}>
            {helperText}
          </FormHelperText>
        )}
      </Box>
    </FormControl>
  );
};

PasswordInput.propTypes = propTypes;

export default PasswordInput;
